import React from 'react'

import Carousel from 'react-bootstrap/Carousel';
import Footer from './component/Footer';
const Description = () => {
  return (
    <div > 
   
    <h1 style={{ fontFamily:'Bangers', color:'#adb5bd', fontSize:'80px', textShadow: '3px 5px 2px rgba(0, 0,0,0.15)'}}>Description</h1>
    <div  className='car'><Carousel slide={false} >
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://cdn.shopify.com/s/files/1/1520/5960/articles/9e623b1c-best-movies-of-2018-the-hundreds-tara-aquino.jpg?v=1545847575"
          alt="First slide"
          style={{width:'800px', height:'562px'}} />
        <Carousel.Caption>
          <h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://cdn.pastemagazine.com/www/articles/best-movies-of-2016.jpg"
          alt="Second slide"
          style={{width:'800px', height:'562px'}}/>

        <Carousel.Caption>
          <h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://bingeddata.s3.amazonaws.com/uploads/2021/06/50-Best-Hollywood-Movies-Streaming-on-Netflix-India.jpg"
          alt="Third slide"
       style={{width:'800px', height:'562px'}} />

        <Carousel.Caption>
          <h3>Third slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
     
    </Carousel>
    </div>



  <h1 style={{ fontFamily:'Bangers', color:'#35a5af', fontSize:'80px', textShadow: '3px 5px 2px rgba(0, 0,0,0.15)', marginBottom:'50px'}}> Movie List:</h1>
    
    





<div class="wrpper">
        <div class="cgrd">
            <img src="https://w0.peakpx.com/wallpaper/632/50/HD-wallpaper-poster-of-avengers-endgame-movie.jpg" />
            <div class="descriptions">
                <h1>Avengers Endgame</h1>
                <p>
                After half of all life is snapped away by Thanos, the Avengers are left scattered and divided.
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://i.pinimg.com/736x/f6/d3/e3/f6d3e3f8351cc091ecd8ed109a2f95ed.jpg" />
            <div class="descriptions">
                <h1>Broken Skine</h1>
                <p>
                A teenage boy, Diego, connects with his teenage ex girlfriend, Karina, .
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2SFUPhK_g3lAprV2SZVjHTkrueIv8VKe1C2Tkc37F9Rh7ynU_PyMAHS6a-gwiCgkx0JY&usqp=CAU" />
            <div class="descriptions">
                <h1>Wonder Women</h1>
                <p>
                Raised on a sheltered island paradise, when a pilot crashes on their
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://cdn.wallpapersafari.com/49/47/GvK7uD.jpg" />
            <div class="descriptions">
                <h1>Dawen Of The Seven</h1>
                <p>
                Seven who will fight. Seven who will restore light and hope, and see 
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
       
        <div class="cgrd">
            <img src="https://i.ytimg.com/vi/8zRNHh0lbNM/maxresdefault.jpg" />
            <div class="descriptions">
                <h1>AVATAR I</h1>
                <p>
                The life of the Navi tribe before the arrival of people
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://bestsimilar.com/img/movie/thumb/1b/12100.jpg" />
            <div class="descriptions">
                <h1>Detective Dee</h1>
                <p>
                The film tells the story of Di Renjie (Andy Lau), one of.
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://lesaliens.com/aliens/wp-content/uploads/2022/03/white-snake_affiche_cinema_kmbo_creation-agence-les-aliens-studio-print_campagne-promotionnelle-instagram.jpg" />
            <div class="descriptions">
                <h1>WHITE SNAKE</h1>
                <p>
                The story follows the Chinese fable the Legend of the White Snake
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://cultea.fr/wp-content/uploads/2022/07/117-1024x512.jpg" />
            <div class="descriptions">
                <h1>Thor</h1>
                <p>
                After reigniting a dormant war, Thor is banished from Asgard to Earth.
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://fr.web.img4.acsta.net/c_310_420/pictures/22/08/23/14/53/3574724.jpg" />
            <div class="descriptions">
                <h1>Le Visiteur de Futur</h1>
                <p>
                Alice, a young girl, protest against the construction of a nuclear plant
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://www.ecranlarge.com/media/cache/1600x1200/uploads/image/001/410/matrix-resurrections-affiche-1410304.jpg" />
            <div class="descriptions">
                <h1>Matrix</h1>
                <p>
                The Matrix is a computer-generated dream world designed to keep these.
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://www.adoxa.info/wp-content/uploads/2022/06/Animaux-Fantastiques-3-le-final-pourrait-creer-un-probleme-de.jpg" />
            <div class="descriptions">
                <h1>Secrets Of Dumbledore</h1>
                <p>
                Set several years after the events of its predecessor, the film sees.
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
        <div class="cgrd">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJ4jQJFmWC5o9DcA2Y4nicBwwCJll8p0O1Uw&usqp=CAU" />
            <div class="descriptions">
                <h1>Gemeni Man</h1>
                <p>
                Henry Brogan, un tueur professionnel, est soudainement pris pour cible et poursuivi par un mystérieux et jeune .
                </p>
                <button>
                    <i class="fab fa-youtube"></i>
                    Play trailer on YouTube
                </button>
            </div>
        </div>
       
        </div>
   
    











  </div>

  )
}

export default Description